import React from "react";
import {
  FiPhone,
  FiMail,
  FiMapPin,
  FiInstagram,
  FiHeart,
} from "react-icons/fi";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "Ana Sayfa", href: "#home" },
    { label: "Hizmetler", href: "#services" },
    { label: "Hakkımda", href: "#portfolio" },
    { label: "İletişim", href: "#contact" },
  ];

  const services = [
    { label: "Aile Danışmanlığı", href: "/aile-danismanligi" },
    { label: "Oyun Terapisi", href: "/oyun-terapisi" },
    { label: "DIRFloortime Terapisi", href: "/dirfloortime-201-terapisti" },
    { label: "Diksiyon Eğitimi", href: "/diksiyon-ve-etkili-konusma" },
  ];

  const handleLinkClick = (href) => {
    if (href.startsWith("#")) {
      const element = document.getElementById(href.substring(1));
      element?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      style={{
        backgroundColor: "#0f172a",
        color: "white",
      }}
    >
      {/* Üst Bölüm */}
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "64px 24px 48px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "48px",
          }}
        >
          {/* Logo ve Açıklama */}
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
             
              <p style={{
                height:"50px",
                width:"auto",
                fontSize:"40px",

                fontWeight:"bold",

              }} >DİLAN ASLAN</p>
            </div>
            <p
              style={{
                color: "#94a3b8",
                lineHeight: "1.75",
                marginBottom: "24px",
                fontSize: "0.95rem",
              }}
            >
              Mardin Artuklu'da çocuk gelişim danışmanlığı, oyun terapisi ve
              ebeveyn danışmanlığı hizmetleri ile çocukların sağlıklı gelişimini
              destekliyoruz.
            </p>
            {/* Sosyal Medya */}
            <div style={{ display: "flex", gap: "12px" }}>
              <a
                href="https://www.instagram.com/cg.dilanaslan/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#1e293b",
                  width: "44px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#94a3b8",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#2563eb";
                  e.currentTarget.style.color = "white";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#1e293b";
                  e.currentTarget.style.color = "#94a3b8";
                }}
              >
                <FiInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h4
              style={{
                fontSize: "1.125rem",
                fontWeight: "600",
                marginBottom: "24px",
                color: "white",
              }}
            >
              Hızlı Linkler
            </h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {quickLinks.map((link, index) => (
                <li key={index} style={{ marginBottom: "12px" }}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      if (link.href.startsWith("#")) {
                        e.preventDefault();
                        handleLinkClick(link.href);
                      }
                    }}
                    style={{
                      color: "#94a3b8",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "color 0.2s ease",
                      display: "inline-block",
                    }}
                    onMouseOver={(e) => (e.target.style.color = "#60a5fa")}
                    onMouseOut={(e) => (e.target.style.color = "#94a3b8")}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Hizmetler */}
          <div>
            <h4
              style={{
                fontSize: "1.125rem",
                fontWeight: "600",
                marginBottom: "24px",
                color: "white",
              }}
            >
              Hizmetlerimiz
            </h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {services.map((service, index) => (
                <li key={index} style={{ marginBottom: "12px" }}>
                  <a
                    href={service.href}
                    style={{
                      color: "#94a3b8",
                      textDecoration: "none",
                      fontSize: "0.95rem",
                      transition: "color 0.2s ease",
                      display: "inline-block",
                    }}
                    onMouseOver={(e) => (e.target.style.color = "#60a5fa")}
                    onMouseOut={(e) => (e.target.style.color = "#94a3b8")}
                  >
                    {service.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* İletişim Bilgileri */}
          <div>
            <h4
              style={{
                fontSize: "1.125rem",
                fontWeight: "600",
                marginBottom: "24px",
                color: "white",
              }}
            >
              İletişim
            </h4>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <a
                href="tel:+905055517747"
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  transition: "color 0.2s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = "#60a5fa")}
                onMouseOut={(e) => (e.currentTarget.style.color = "#94a3b8")}
              >
                <div
                  style={{
                    backgroundColor: "#1e293b",
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                  }}
                >
                  <FiPhone size={18} color="#60a5fa" />
                </div>
                +90 505 551 77 47
              </a>

              <a
                href="mailto:info@dilanaslan.com"
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#94a3b8",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  transition: "color 0.2s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = "#60a5fa")}
                onMouseOut={(e) => (e.currentTarget.style.color = "#94a3b8")}
              >
                <div
                  style={{
                    backgroundColor: "#1e293b",
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                  }}
                >
                  <FiMail size={18} color="#60a5fa" />
                </div>
                info@dilanaslan.com
              </a>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  color: "#94a3b8",
                  fontSize: "0.95rem",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#1e293b",
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "12px",
                    flexShrink: 0,
                  }}
                >
                  <FiMapPin size={18} color="#60a5fa" />
                </div>
                <span>Artuklu, Mardin / Türkiye</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Alt Bölüm - Copyright */}
      <div
        style={{
          borderTop: "1px solid #1e293b",
          padding: "24px",
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <p
            style={{
              color: "#64748b",
              fontSize: "0.875rem",
              margin: 0,
            }}
          >
            © {currentYear} Dilan Aslan | Çocuk Gelişim Danışmanlığı. Tüm
            hakları saklıdır.
          </p>
          <p
            style={{
              color: "#64748b",
              fontSize: "0.875rem",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            
            <a
              href="https://www.instagram.com/akn.yazilim/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#60a5fa",
                textDecoration: "none",
                fontWeight: "500",
              }}
              onMouseOver={(e) => (e.target.style.color = "#93c5fd")}
              onMouseOut={(e) => (e.target.style.color = "#60a5fa")}
            >
              AKN YAZILIM
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
